import { FormField } from 'components/shared/form';
import {
  financingTermsFormFields,
  financingTermsFormHelpers,
} from 'components/underwriting/financing-terms/financingTermsFormConfig';

export const proFormaFormFields: FormField[] = [...financingTermsFormFields];

export const proFormaFormHelpers = {
  ...financingTermsFormHelpers,
};
